import * as React from 'react';
import { styled, css } from '../theme-provider';
import { DisplayTag } from '../display-tag';
export var InputAppearance;
(function (InputAppearance) {
    InputAppearance[InputAppearance["Default"] = 0] = "Default";
    InputAppearance[InputAppearance["Information"] = 1] = "Information";
    InputAppearance[InputAppearance["Disabled"] = 2] = "Disabled";
    InputAppearance[InputAppearance["Error"] = 3] = "Error";
    InputAppearance[InputAppearance["Success"] = 4] = "Success";
    InputAppearance[InputAppearance["ReadOnly"] = 5] = "ReadOnly";
    InputAppearance[InputAppearance["Validation"] = 6] = "Validation";
})(InputAppearance || (InputAppearance = {}));
export const getMainColor = css `${({ theme, appearance }) => {
    switch (appearance) {
        case InputAppearance.ReadOnly:
            return theme.colors.content.primary;
        case InputAppearance.Disabled:
            return theme.colors.content.secondary;
        default:
            return 'inherit';
    }
}}`;
export const getLabelColor = css `${({ theme, appearance }) => {
    switch (appearance) {
        case InputAppearance.ReadOnly:
            return theme.colors.content.primary;
        case InputAppearance.Disabled:
            return theme.colors.content.secondary;
        default:
            return theme.colors.content.active;
    }
}}`;
// color for borders, etc.
export const getAuxillaryColor = css `${({ theme, appearance }) => {
    switch (appearance) {
        case InputAppearance.Error:
            return theme.colors.signal.error;
        case InputAppearance.Success:
            return theme.colors.signal.success;
        case InputAppearance.Information:
            return theme.colors.signal.neutral;
        case InputAppearance.Disabled:
            return theme.colors.border.default;
        default:
            return theme.colors.signal.info;
    }
}}`;
// color for character counter
export const getAuxillaryTextColor = css `${({ theme }) => theme.colors.content.secondary}`;
// color for notifications
export const getNotificationColor = css `${({ theme, appearance }) => {
    switch (appearance) {
        case InputAppearance.Error:
        case 'error':
            return theme.colors.signal.error;
        case InputAppearance.Success:
        case 'success':
            return theme.colors.signal.success;
        default:
            return theme.colors.signal.neutral;
    }
}}`;
/**
 * This is used to map the common appearances values between InputAppearance and DisplayTagAppearance,
 * i.e. SUCCESS, ERROR, INFORMATION
 */
const appearancesMap = {
    Error: 'error',
    Information: 'alert',
    Success: 'success',
};
//this is needed otherwise there gap is shown and the display tag looks asymmetric when no text is provided
const StyledDisplayTag = styled(DisplayTag).withConfig({ displayName: "StyledDisplayTag", componentId: "sc-1p6dz7j" }) `display:flex;overflow-wrap:anywhere;word-break:break-word;background:${getNotificationColor};color:${({ theme, appearance }) => {
    if (appearance === 'success') {
        return theme.colors.content.inverted;
    }
    return theme.colors.content.onsurface;
}};svg{margin:-${({ theme }) => theme.size.line.active};flex:none;}${({ theme, text }) => {
    if (text) {
        return css `
				height: auto;
				margin-top: ${theme.size.static100};
				padding: ${theme.size.line.active} ${theme.size.static200};
				gap: ${theme.size.static150};

				svg {
					position: relative;
					top: ${theme.size.static150};
					align-self: start;
				}
			`;
    }
    return css `
			gap: 0;
			position: absolute;
			bottom: ${theme.size.line.active};
			${theme.direction === 'rtl' ? `left: 0;` : `right: 0;`};
		`;
}}`;
//this function is used to display the DisplayTag component when the input/text area appearance is set to
// InputAppearance.Information, InputAppearance.Error or InputAppearance.Success
export const DisplayNotification = ({ appearance, notificationMessage, id }) => {
    const appearanceValue = InputAppearance[appearance];
    return Object.keys(appearancesMap).includes(appearanceValue) ? (React.createElement(StyledDisplayTag, { appearance: appearancesMap[appearanceValue], text: notificationMessage, hideIcon: appearanceValue === 'Information' || appearanceValue === 'Validation', id: id })) : null;
};
